module.exports = __webpack_public_path__ + "images/28e4c84da98938f181790419a8d7128f.png";